export const enum Metric {
  Enquiry = "Enquiry",
  View = "View",
}

export const enum ObjectType {
  Project = "Project",
  Organisation = "Organisation",
}
